<template>
  <label :class="['block', wrapperClass]">
    <span v-if="label" class="label">{{ label }}</span>
    <input
      :value="modelValue"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :min="min"
      class="field"
      v-bind="inputAttrs"
      @input="onInput"
    />
  </label>
</template>

<script lang="ts">
import { computed, useAttrs } from "vue";

export default {
  inheritAttrs: false,
  props: {
    modelValue: { type: [String, Number], default: "" },
    modelModifiers: { type: Object, default: () => ({}) },
    label: { type: String, default: "" },
    type: { type: String, default: "text" },
    placeholder: { type: String, default: "" },
    required: { type: Boolean, default: false },
    min: { type: [String, Number], default: undefined },
  },
  emits: ["update:modelValue"],
  setup(props: any, { emit }: any) {
    const attrs = useAttrs();
    const wrapperClass = computed(() => attrs.class);
    const inputAttrs = computed(() => {
      const next = { ...attrs };
      delete next.class;
      return next;
    });
    const onInput = (event: Event) => {
      const target = event.target as HTMLInputElement;
      emit("update:modelValue", props.modelModifiers.number ? Number(target.value) : target.value);
    };
    return { onInput, wrapperClass, inputAttrs };
  },
};
</script>
